/*
Created-by: XtroEdge AI
Updated-by: XtroEdge AI
Last modified: 2026-11-03T10:30:00+05:00
Intent: One "no campaigns left in the plan" check and popup, shared by Create Campaign (type picker) and the campaign form.
*/
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NzModalService } from 'ng-zorro-antd/modal';

/** Navigation state flag: the client already saw the warning on Create Campaign and chose Continue. */
export const NO_CAMPAIGNS_LEFT_ACKNOWLEDGED = 'noCampaignsLeftAcknowledged';

/** Campaigns allowed and created, as PURCHASED_PLAN answers them. 0 allowed means no limit. */
export function campaignAllowance(plan: any): { allowed: number; created: number } {
  return {
    allowed: Number(plan?.contest_allowed ?? plan?.sub_plan?.Contest_allowed ?? 0) || 0,
    created: Number(plan?.contest_created ?? 0) || 0,
  };
}

export function hasNoCampaignsLeft(allowed: number, created: number): boolean {
  return allowed > 0 && created >= allowed;
}

/** The campaign can still be filled in and saved as a draft, but not submitted. Custom footer
 * buttons (not modal.confirm) so the "X" only dismisses the dialog and never triggers either action. */
export function openNoCampaignsLeftModal(
  modal: NzModalService,
  translate: TranslateService,
  router: Router,
  messageKey: string,
  secondary: { label: string; onClick: () => void },
): void {
  const modalRef = modal.create({
    nzTitle: translate.instant('addContests.noCampaignsLeftTitle'),
    nzContent: translate.instant(messageKey),
    nzCentered: true,
    nzClosable: true,
    nzClassName: 'contest-styled-modal contest-modal-warning no-campaigns-left-modal',
    nzFooter: [
      {
        label: secondary.label,
        onClick: () => {
          modalRef.close();
          secondary.onClick();
        },
      },
      {
        label: translate.instant('addContests.noCampaignsLeftUpgrade'),
        type: 'primary',
        onClick: () => {
          modalRef.close();
          // Plans are changed on the subscription page (the old /upgrade screen redirects there).
          router.navigate(['/home/subscription']);
        },
      },
    ],
  });
}
